










































































































































































import Vue from "vue";

import { Api } from "@/common/api";
import Url from "../../helpers/Url";
import { isEmail, isEmpty, isNumeric, isMatches } from "@/helpers/validator";

import { VButton } from "@/components/button";
import { VForm } from "@/components/form";
import { VInput } from "@/components/input";
import ImgSuccess from "@/assets/images/success.svg?inline";

import { RegistrationClaim } from "@/types";

const getDefaultRegistrationClaim = (): RegistrationClaim => ({
  email: "",
  name: "",
  phone: "",
  agreement: true,
  captcha: "",
  dealerId: null,
  country: 'ru',
  typeVerificationCode: "3" //  Подтверждения регистрации по звонку.
});

let productName = "";
switch (window.location.pathname){
  case "/products/r_keeper_cloud/":
    productName = "<span class='logo-wrapper'><span class='logo'>r_k </span><span class='logo-green'>Cloud</span></span>";
    break;
  case "/products/delivery/":
    productName = "<span class='logo-wrapper'><span class='logo'>r_k </span><span class='logo-green'>DELIVERY</span></span>";
    break;
  default:
    productName = "<span class='logo-wrapper'><span class='logo'>r_k </span><span class='logo-green'>Lite</span></span>";
    break;
}

export default Vue.extend({
  name: "RegForm",

  components: {
    VForm,
    VInput,
    VButton,
    ImgSuccess
  },

  data() {
    return {
      error: "",
      loading: false,
      registrationClaim: getDefaultRegistrationClaim(),
      resendTime: 60,
      success: false,
      timeLeft: 0,
      timer: null as any,
      verificationCode: "",
      userLogin: "",
      dataAgreement: "/privacy-policy/"
    };
  },

  computed: {
    title(): string {
      return this.success
        ? "Регистрация прошла успешно"
        : "Зарегистрируй свой "+ productName;
    },

    description(): string {
      if (this.success) {
        return "На вашу почту было направлено сообщение";
      }

      return this.userLogin
        ? "На указанный номер направлен звонок. <br>Введите последние 4 цифры в поле ниже."
        : "Создайте аккаунт в "+ productName + ". 14 дней бесплатно";
    },

    valid(): boolean {
      if (
        !this.registrationClaim.name ||
        !this.registrationClaim.phone ||
        !this.registrationClaim.email ||
        !this.registrationClaim.agreement
      ) {
        return false;
      }

      return true;
    }
  },

  async mounted() {
    const href = window.location.href;
    const url = new Url(href);
    const params: any = url.paramsObj;
    const dealerId = params.dealerId || null;
    this.registrationClaim.dealerId = dealerId;
    this.registrationClaim.country = 'ru';
  },

  methods: {
    isEmail,
    isEmpty,
    isMatches,
    isNumeric,

    async isFreeClientName(name: string): Promise<boolean | string> {
      try {
        return (await Api.isFreeName(name)) ? true : "Это имя занято";
      } catch (err) {
        return err.message;
      }
    },

    async registerClient(): Promise<void> {
      this.error = "";
      this.loading = true;

      try {
        await this.$recaptchaLoaded();
        // const token = await this.$recaptcha("login");
        await this.$recaptcha("login");

        this.registrationClaim.captcha = await this.$recaptcha("registration");
        this.registrationClaim.phone = this.registrationClaim.phone.replace(
          /[^+\d]/g,
          ""
        );
        if(!this.registrationClaim.country) this.registrationClaim.country = 'ru';
        console.log(this.registrationClaim.country, 'registrationClaim.country')
        console.log(this.registrationClaim, 'registrationClaim')
        this.userLogin = (
          await Api.registerClient(this.registrationClaim)
        ).userLogin;

        this.startCountdown();

        if (window.ym !== undefined) {
          window.ym(62223283, "reachGoal", "client-phone-verified");
        }

        if (window._tmr !== undefined) {
          const _tmr = window._tmr || (window._tmr = []);
          _tmr.push({"type":"reachGoal","id":3210913,"goal":"arrows"});
        }


        this.loading = false;
      } catch (e) {
        this.loading = false;
        let errorMessage = null;
        try {
          errorMessage = e.message;
        } catch (error) {
          errorMessage = "Что-то пошло не так, отсутствует текст ошибки";
          console.error(e);
          console.error(error);
        }
        this.error = errorMessage;
      }
    },

    async confirmPhone(): Promise<void> {
      this.error = "";
      this.loading = true;

      console.log(this.registrationClaim, 'registrationClaim confirmPhone');
      try {
        await Api.confirmPhone({
          userName: this.registrationClaim.name,
          country: this.registrationClaim.country,
          userLogin: this.userLogin,
          verificationCode: this.verificationCode,
          captcha: await this.$recaptcha("registration")
        });

        this.loading = false;
        this.success = true;

        try {
          const { dataLayer } = window;
          if (dataLayer !== undefined) {
            dataLayer.push({ event: "regLiteForm" });
          }
        } catch (e) {
          console.log(e);
        }

        this.registrationClaim = getDefaultRegistrationClaim();
      } catch (e) {
        this.loading = false;
        this.error = e.message;
      }
    },

    startCountdown(): void {
      this.timeLeft = this.resendTime;
      this.timer = setInterval(() => {
        this.timeLeft -= 1;
      }, 1000);

      setTimeout(() => {
        clearInterval(this.timer);
        this.timer = null;
      }, this.resendTime * 1000);
    },

    async resendCode(): Promise<void> {
      try {
        await Api.resendVerificationCode(this.userLogin);
        this.startCountdown();
      } catch (err) {
        this.error = err.message;
      }
    },

    back(): void {
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.userLogin = "";
      this.success = false;
    },

    reset(): void {
      this.registrationClaim = getDefaultRegistrationClaim();
    },

    complete(): void {
      this.reset();
      this.back();

      this.$emit("success");
    }
  }
});
